<ng-template #surfaceElement>
    <div
        #dialogSurface
        class="overlay-dialog"
        [class.overlay-dialog--fullscreen]="fullScreen()"
        [style.width.px]="fullScreen() ? null : width()"
    >
        <div class="overlay-dialog__content p-6 pb-0">
            <ng-content></ng-content>
        </div>
        @if (fullScreen()) {
            <div class="overlay-dialog__divider p-2"></div>
        }
        <div class="overlay-dialog__footer flex justify-end gap-4 px-6 pb-6 pt-4 max-sm:flex-col-reverse max-sm:items-stretch">
            @if (fullScreen()) {
                <button mat-stroked-button class="ca-button ca-button-m max-sm:w-full" (click)="cancel()">
                    {{ 'BUTTON.CANCEL' | translate }}
                </button>
            }
            <button mat-flat-button class="ca-button ca-button-m max-sm:w-full" (click)="confirm()">
                <ca-icon icon="unlock" class="ca-icon-s-16-p-0-f-16 me-2 mb-0.5"></ca-icon>
                {{ confirmLabel() }}
            </button>
        </div>
    </div>
</ng-template>

@if (!fullScreen()) {
    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="anchorElement()"
        [cdkConnectedOverlayOpen]="open()"
        [cdkConnectedOverlayPositions]="positions()"
        [cdkConnectedOverlayHasBackdrop]="false"
    >
        <ng-container [ngTemplateOutlet]="surfaceElement"></ng-container>
    </ng-template>
}
